import React from 'react';
import PropTypes from 'prop-types';

import RoundButton from '../../../../components/_atomic/RoundButton/RoundButton';

import { getURLParameters, getSearch, generatePassword } from '../../../../utils/helpers';
import { ERROR, API_ROUTES, SUCCESS } from '../../../../utils/constants';

const linkedinIcon = require('../../../../assets/images/AuthFlow/linkedin.png');

const clientId = '77l0f5hk7sxd6z';
export default class LoginWithLinkedin extends React.Component {
  static propTypes = {
    getToken: PropTypes.func.isRequired,
    login: PropTypes.func.isRequired,
    status: PropTypes.string.isRequired,
    registrationStatus: PropTypes.string.isRequired,
    accessToken: PropTypes
      .shape({})
      .isRequired,
  }
  state = {
    redirectUri: '',
    redirectUriWithoutEncode: '',
    csrfPrevent: '',
  }

  componentWillMount() {
    const documentLocation = document.location;
    let { location, redirectUriWithoutEncode, csrfPrevent } = this.state;

    // do this for develop at localhost
    if (documentLocation.hostname === 'localhost') {
      location = `http%3A%2F%2Flocalhost:5000${window.encodeURIComponent(documentLocation.pathname)}`;
    } else {
      location = window.encodeURIComponent(`${documentLocation.origin}${documentLocation.pathname}`);
    }
    redirectUriWithoutEncode = `${documentLocation.origin}${documentLocation.pathname}`;
    csrfPrevent = generatePassword(20);
    this.setState(() => ({ redirectUri: location, redirectUriWithoutEncode, csrfPrevent }));
  }

  componentDidMount() {
    const searchParams = getSearch();

    if (searchParams) {
      const searchParamsObj = getURLParameters(searchParams);
      const { redirectUriWithoutEncode } = this.state;
      if (searchParamsObj.code) {
        this
          .props
          .getToken({ code: searchParamsObj.code, redirectUri: redirectUriWithoutEncode });
      }
    }
  }


  componentDidUpdate(prevProps) {
    const { accessToken, status, registrationStatus } = this.props;
    if (accessToken !== prevProps.accessToken) {
      this.props.login({ route: API_ROUTES.LINKEDIN_LOGIN, token: accessToken.access_token });
    }
    if (status === ERROR || registrationStatus === ERROR || registrationStatus === SUCCESS) {
      this.clearSearch();
    }
  }
  clearSearch = () => {
    const uri = window
      .location
      .toString();
    if (uri.indexOf('?') > 0) {
      const cleanUri = uri.substring(0, uri.indexOf('?'));
      window
        .history
        .replaceState({}, document.title, cleanUri);
    }
  }
  render() {
    const { redirectUri, csrfPrevent } = this.state;

    return (
      <a
        className="linkedin-link"
        href={`https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${csrfPrevent}`}
      >
        <RoundButton radius="32px"><img src={linkedinIcon} alt="LinkedingIcon" /></RoundButton>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/SocialLoginWrapper/components/LinkedinLoginButton/LinkedinLoginButton.js